import { mergeStyleSets } from '@fluentui/react';

export const useStyles = () => mergeStyleSets({
  constantMappingEditor: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  valueEdit: {
    display: 'flex',
    gap: '4px',
    '& :first-child': {
      flexGrow: 1,
    }
  }
})
